type ScrollToState = 'nearest' | 'center' | 'end' | 'start'

interface ScrollIntoViewParams {
  block: ScrollToState
  inline: ScrollToState
  behavior: 'smooth' | 'instant' | 'auto'
}

export const scrollIntoView = (
  selector: string,
  params?: Partial<ScrollIntoViewParams>,
) => {
  const el = document.querySelector(selector)
  if (el) {
    console.log('scrollIntoView', el)
    el.scrollIntoView({
      block: 'nearest',
      inline: 'center',
      behavior: 'smooth',
      ...params,
    })
  } else {
    console.log('scrollIntoView: element not found', selector)
  }
}
